import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const MemberAuthContext = createContext(null);

export function MemberAuthProvider({ children }) {
  const [member, setMember] = useState(null); // null = anon, object = signed-in member
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/member/me");
      setMember(data);
      return data;
    } catch {
      setMember(null);
      return null;
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from the OAuth callback, skip the /me check.
    // AuthCallback exchanges the session_id and establishes the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const signOut = async () => {
    try {
      await api.post("/member/logout");
    } catch (e) {
      console.warn("Logout request failed:", e);
    }
    setMember(null);
  };

  return (
    <MemberAuthContext.Provider value={{ member, loading, refresh, signIn, signOut, setMember }}>
      {children}
    </MemberAuthContext.Provider>
  );
}

export const useMember = () =>
  useContext(MemberAuthContext) || {
    member: null,
    loading: false,
    refresh: async () => null,
    signIn: () => {},
    signOut: async () => {},
    setMember: () => {},
  };
